export const InformationData = {
  FirstName: "Mankumar",
  LastName: "Mendapara",
  Designation: "Software Engineer",
  Email: "mannmendapara13@gmail.com",
  Hobbies: ["Playing Volleyball", "Cooking", "Sketching"],
  AboutMe: ", an enthusiastic web developer with a passion for turning concepts into digital reality. My journey in web development has been marked by a relentless pursuit of creative solutions and a dedication to crafting engaging web experiences. I thrive on the ever-evolving nature of this field, where each project offers a chance to learn and innovate. I'm driven by the desire to create seamless online interactions, bridging the gap between businesses and their audiences.",
  ProfileTags: [
    "Passionate Developer.",
    "Japanese Learner.",
    "Volleyball Player.",
  ],
  Greetings: {
    HeyIam: "Hey, I'm",
    HiThere: "Hi There!",
  }
};
